function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0cal{fill:#F0F0F0;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0cal",
  d: "M23.79,26.07H1.94C0.87,26.07,0,25.2,0,24.14V5.07C0,4,0.87,3.13,1.94,3.13h21.85c1.07,0,1.94,0.87,1.94,1.94 v19.07C25.73,25.2,24.86,26.07,23.79,26.07z M1.94,3.82c-0.69,0-1.24,0.56-1.24,1.24v19.07c0,0.69,0.56,1.24,1.24,1.24h21.85 c0.69,0,1.24-0.56,1.24-1.24V5.07c0-0.69-0.56-1.24-1.24-1.24H1.94z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 6.61,
  y: 8.34,
  className: "st0cal",
  width: 0.7,
  height: 17.38
}), /*#__PURE__*/React.createElement("rect", {
  x: 12.86,
  y: 8.34,
  className: "st0cal",
  width: 0.7,
  height: 17.38
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.35,
  y: 13.94,
  className: "st0cal",
  width: 25.03,
  height: 0.7
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.35,
  y: 19.5,
  className: "st0cal",
  width: 25.03,
  height: 0.7
}), /*#__PURE__*/React.createElement("rect", {
  x: 19.12,
  y: 8.34,
  className: "st0cal",
  width: 0.7,
  height: 17.38
}), /*#__PURE__*/React.createElement("path", {
  className: "st0cal",
  d: "M25.38,9.73H0.35V5.76c0-1.26,1.02-2.29,2.29-2.29h20.46c1.26,0,2.29,1.02,2.29,2.29V9.73z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0cal",
  d: "M5.91,8.34L5.91,8.34c-0.77,0-1.39-0.62-1.39-1.39V1.39C4.52,0.62,5.14,0,5.91,0h0C6.68,0,7.3,0.62,7.3,1.39 v5.56C7.3,7.72,6.68,8.34,5.91,8.34z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0cal",
  d: "M19.12,8.34L19.12,8.34c-0.77,0-1.39-0.62-1.39-1.39V1.39c0-0.77,0.62-1.39,1.39-1.39h0 c0.77,0,1.39,0.62,1.39,1.39v5.56C20.51,7.72,19.89,8.34,19.12,8.34z"
}));

var SvgMenuCalendar = function SvgMenuCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.73 26.07",
    style: {
      enableBackground: "new 0 0 25.73 26.07"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu_Calendar.176bdf3c.svg";
export { ForwardRef as ReactComponent };